/// <amd-module name="Artifacts/Connect/containers/ConnectToFeedContainer" />
import { ConnectToFeed } from "Artifacts/Connect/components/ConnectToFeed";
import { useToolsListRouting } from "Artifacts/Connect/hooks/ListRouting";
import { useConnectToFeedList } from "Artifacts/Connect/hooks/Tools";
import { ConnectToFeedActions } from "Artifacts/Connect/redux/Actions";
import { IConnectToFeedContainerOwnState } from "Artifacts/Connect/redux/Contracts";
import { getConnectToFeedModule } from "Artifacts/Connect/redux/Module";
import { CombinedFeedView } from "Artifacts/Connect/types/ICombinedFeedView";
import { ToolId } from "Artifacts/Connect/types/ITool";
import { DefaultLoader } from "Artifacts/Root/components/DefaultLoader";
import { getSelectedView } from "Artifacts/Root/helpers/FeedHelpers";
import { useFeed } from "Artifacts/Root/hooks/FeedUrlResolver";
import { connectDynamicModules } from "Artifacts/Root/redux";
import { feedHubRoute } from "Artifacts/Root/routing/Constants";
import { connectContainerName } from "Artifacts/Root/routing/Definitions";
import { Components, useComponentContext } from "VSS/Platform/Layout";
import { Uri } from "VSS/Platform/Util/Url";
import * as React from "react";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { generatePath, useHistory } from "react-router-dom";

const Actions = {
  dismissFirstTimeMessage: ConnectToFeedActions.dismissFirstTimeMessage,
  loadInitialData: ConnectToFeedActions.loadInitialData,
};

const ConnectToFeedContainer: React.FC<IConnectToFeedContainerMapStateToProps & typeof Actions> = ({
  dismissFirstTimeMessage,
  loadInitialData,
  dismissedTools,
  packagingUrl,
  sessionTokenUri,
}) => {
  const history = useHistory();
  const { pageContext } = useComponentContext();
  const { feed, resolution } = useFeed();
  const [combinedFeedView, setCombinedFeedView] = useState<CombinedFeedView | undefined>();
  React.useEffect(() => {
    feed && loadInitialData(feed);
  }, [loadInitialData, feed]);

  useEffect(() => {
    if (feed) {
      const view = getSelectedView(feed);
      setCombinedFeedView(new CombinedFeedView(feed, view));
    }
  }, [feed]);

  const { toolsItemProvider, protocolNames, selectedTool, selectTool } = useConnectToFeedList(
    pageContext,
    combinedFeedView,
  );

  // Effect hook that synchronizes URL route with selected item in the tool list.
  useToolsListRouting(toolsItemProvider, selectTool);

  return (
    <DefaultLoader state={resolution}>
      <ConnectToFeed
        itemProvider={toolsItemProvider}
        protocolNames={protocolNames}
        pageContext={pageContext}
        selectedTool={selectedTool}
        onBackButtonClick={() =>
          history.push(generatePath(feedHubRoute, { feedIdentifier: feed?.name }))
        }
        onSelectedToolBackClick={() => selectTool(undefined)}
        selectTool={selectTool}
        combinedFeedView={combinedFeedView}
        dismissedTools={dismissedTools}
        packagingUrl={packagingUrl}
        sessionTokenUri={sessionTokenUri}
        onDismissFirstTimeMessage={(toolId: ToolId) => dismissFirstTimeMessage(toolId)}
      />
    </DefaultLoader>
  );
};

function mapStateToProps(
  state: IConnectToFeedContainerOwnState,
): IConnectToFeedContainerMapStateToProps {
  return {
    dismissedTools: state.connectToFeed.dismissedTools,
    packagingUrl: state.connectToFeed.packagingUrl,
    sessionTokenUri: state.connectToFeed.sessionTokenUri,
  };
}

interface IConnectToFeedContainerMapStateToProps {
  dismissedTools: ToolId[];
  packagingUrl: string;
  sessionTokenUri: Uri;
}

const ConnectedConnectToFeedContainer = connectDynamicModules(
  connect<IConnectToFeedContainerMapStateToProps, unknown, unknown>(
    mapStateToProps,
    Actions,
  )(ConnectToFeedContainer),
  getConnectToFeedModule(),
);

export { ConnectedConnectToFeedContainer as ConnectToFeedContainer };

Components.add(connectContainerName, ConnectedConnectToFeedContainer);
